var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityVoting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 67.733 67.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-5.197 5.67H23.157V26.950000000000003H-5.197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.197 9.449H11.812000000000001V35.246H5.197z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeWidth: 7.559,
    d: "M204.91 17.744S134.096 22.74 98.836 60.352c-35.26 37.61-79.924 143.392-79.924 143.392s19.216-5.926 24.682-13.076c5.465-7.15 4.261-25.27 4.261-25.27s23.067 3.966 35.702-1.029c12.635-4.995 28.207-38.2 28.207-38.2l-24.24-24.314L116.905 120s1.52-1.372 3.809-3.408a52.347 52.347 0 01-1.588-12.799 52.347 52.347 0 0152.346-52.348 52.347 52.347 0 0115.4 2.319c11.075-17.833 18.037-36.02 18.037-36.02z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeDashoffset: 37.795,
    strokeLinecap: "round",
    strokeWidth: 0.874,
    transform: "matrix(1.14385 0 0 1.14385 -6.267 -3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.012,
    d: "M52.152 37.514a9.102 9.102 0 01-5.224 3.525l6.36 11.34.489-5.548 4.989 2.477z",
    transform: "matrix(1.3036 0 0 1.3036 -14.923 -15.379)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2.012,
    d: "M42.196 39.22v14.702l3.14-4.6 3.14 4.6V40.327a9.102 9.102 0 01-1.662.153 9.102 9.102 0 01-4.618-1.26z",
    transform: "matrix(1.3036 0 0 1.3036 -14.923 -15.379)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.874
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 9.913,
    d: "M171.24 63.594a40.2 40.2 0 00-39.967 40.199 40.2 40.2 0 0040.2 40.2 40.2 40.2 0 0040.2-40.2 40.2 40.2 0 00-40.2-40.2 40.2 40.2 0 00-.233 0zm-.04 6.424a33.776 33.776 0 01.273 0 33.776 33.776 0 0133.777 33.775 33.776 33.776 0 01-33.777 33.775 33.776 33.776 0 01-33.776-33.775A33.776 33.776 0 01171.2 70.018z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 11.339,
    d: "M172.455 73.148a30.873 30.873 0 00-30.873 30.872 30.873 30.873 0 0030.873 30.873 30.873 30.873 0 0030.873-30.873 30.873 30.873 0 00-30.873-30.872zm4.176 7.748h1.035v34.817c0 2.616.116 4.289.346 5.021.23.712.71 1.3 1.443 1.76.733.46 1.906.69 3.518.69h.972v1.162h-22.414v-1.162h1.13c1.82 0 3.117-.209 3.892-.627.774-.419 1.298-.994 1.57-1.727.272-.732.408-2.438.408-5.117v-22.07c0-1.968-.095-3.19-.283-3.672-.188-.503-.543-.921-1.066-1.256-.503-.356-1.088-.535-1.758-.535-1.068 0-2.365.336-3.893 1.006l-.566-1.131z",
    transform: "matrix(.2313 0 0 .2313 5.479 3.401)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityVoting);
export default __webpack_public_path__ + "static/media/community_voting.5bbfcee0113ab39aaf13415ced761ce9.svg";
export { ForwardRef as ReactComponent };